import React from 'react';
import AniLink from 'gatsby-plugin-transition-link/AniLink';
import Loadable from '@loadable/component';

import './operational-methods.styles.scss';

const Slide = Loadable(() => import('react-reveal/Slide'));

const OperationalMethods = () => {
  return (
    <Slide right>
      <div className="about res-pt-0 pb-100 pt-70">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="about-image">
                <img
                  src={require('../../assets/photos/mission/mission.png')}
                  alt="mission"
                />
              </div>
            </div>

            <div className="col-lg-6 col-md-12">
              <div className="about-content">
                <div className="content">
                  <h2>We Pick Up Where Transit Drops Off.</h2>
                  <p>
                    Hop In is a solution for employers to recruit and retain
                    talent. We work with employers to expand hiring pools and
                    offer retention support through our shuttle services.
                  </p>

                  <AniLink
                    paintDrip
                    hex="#ff5d22"
                    to="/offerings"
                    className="default-btn"
                  >
                    <i className="flaticon-right"></i>
                    Learn More <span></span>
                  </AniLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Slide>
  );
};

export default OperationalMethods;
